import * as React from 'react'
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import { useState, useEffect } from 'react';
import { Pagination } from 'src/reusable/global';
import { useSearchParams } from 'react-router-dom';
import Helper from 'src/support/Helper';
import useReduxState from 'src/hooks/useReduxState';
import NoResultContent from '../../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
const ArticlesList = () => {
    const [{ articleList }, { get_article_list }] = useHomePageContentStore();
    const [list, setList] = useState({});

    const [firstServerCall, setFirstServerCall] = useState(true);
    const [searchParams] = useSearchParams();

    const [selectedFilterList] = useReduxState([], 'selectedFilterList');
    const [__check] = useAxiosIndicatorCheck();

    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: 'articleSortBy'
    });
    useEffect(() => {
        async function fetchHere() {
            if (articleList && articleList.list && articleList.list.length > 0) {
                await fetchData()
                await setFirstServerCall(false);
            }
        }
        fetchHere()
    }, [articleList]);

    useEffect(() => {
        const getList = async () => {
            setTimeout(async () => {
                await fetchAPiCall();
            }, 500);
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.sortBy]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [selectedFilterList]);

    const fetchData = async () => {
        const data = articleList && articleList.list
        const total = articleList && articleList.count;
        setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
        setList(data);
    };

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 })
    }

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, limit: event.target.value })
    };

    const fetchAPiCall = async (
        defaultStart = false
    ) => {
        __set("CONTENT_API_CALL");
        let search_keyword = searchParams.get('search')
        await get_article_list({
            "page": listObj.page,
            "limit": listObj.limit,
            "sort": listObj.sortBy,
            "searchParam": search_keyword,
            "filterList": selectedFilterList
        })
        __remove("CONTENT_API_CALL");
    };

    return (
        <>
            {
                <>
                    <div className='position-relative'>
                        <div>
                            {__check(['CONTENT_API_CALL'], { overlay: true }).render}
                        </div>
                        <div className='all-content-body'>
                            {list && list.length > 0 && list.map((v, i) => (
                                <div key={i} className='all-content-body-item'>
                                    <div className='bs5 row mx-0'>
                                        <div className='col-lg-9 col-md-12 ps-0'>

                                            <div className='font-16 text-blue2 font-bold mb-1 11'>
                                                <a href={v.url} target="_blank" className="text-blue2">{v.name}</a>
                                                <span className='content-tag'>{v.pageType}</span></div>
                                            <div>{v.date}</div>
                                            <div className='ellipses' title="">
                                                {v.shortDesc}
                                            </div>
                                            <a href={v.url} target="_blank" className="text-blue2">Read More</a>
                                        </div>
                                        <div className='col-lg-3 col-md-12 ps-0 text-start text-lg-end'>
                                            <div className='new-content-img'>
                                                <img className='img-fluid articleimage' src={v.image} />
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            ))
                            }
                            {firstServerCall === false && (list === undefined || list === null || Object.entries(list).length === 0) &&
                                searchParams.get('search') !== undefined && searchParams.get('search') !== null && searchParams.get('search') !== '' &&
                                <NoResultContent message={'No Articles Found for <b>"' + searchParams.get('search') + '"</b>'} />
                            }
                        </div>
                        {list && list.length > 0 &&
                            <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                        }
                    </div>
                </>
            }


        </>
    )
}

export default ArticlesList